import React, { useState } from "react";
import styled from "styled-components";
import DesignDrawer from "./DesignDrawer";
import PreviewImage from "./PreviewImage";
import { useAuth } from "../../../../contexts/AuthContext";
import { AuthConstants } from "../../../../constants/AuthConstants";

const PreviewContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  width: 300px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.div`
  font-family: Helvetica;
  font-size: 16px;
  font-weight: normal;
  color: #000000;
`;

const EditButton = styled.div`
  font-family: Helvetica;
  font-size: 14px;
  font-weight: normal;
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  color: ${(props) => (props.disabled ? "#dee5ed " : "#4c8cee")};
`;

const CardPreview = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const { hasRole } = useAuth();
  const handleSaved = () => {
    setRefreshKey((prev) => prev + 1);
  };

  const handleClose = () => {
    setDrawerOpen(false);
  };

  return (
    <>
      <PreviewContainer>
        <PreviewImage refreshKey={refreshKey} />
        <ContentWrapper>
          <Title>Card Preview</Title>
          <EditButton
            onClick={() => !hasRole(AuthConstants.ROLES.VIEW_ONLY) && setDrawerOpen(true)}
            disabled={hasRole(AuthConstants.ROLES.VIEW_ONLY)}
          >
            edit design
          </EditButton>
        </ContentWrapper>
      </PreviewContainer>

      <DesignDrawer open={drawerOpen} onClose={handleClose} onSaved={handleSaved} />
    </>
  );
};

export default CardPreview;
